import { useState, type FormEvent } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

interface Props {
  onAdd: (email: string) => Promise<void>;
  buttonLabel?: string;
}

export function AddUserForm({ onAdd, buttonLabel = "Invite" }: Props) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const valid = EMAIL_RE.test(email.trim());

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    setError(null);
    try {
      await onAdd(email.trim().toLowerCase());
      setEmail("");
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-2">
      <div className="flex items-center gap-2 rounded-md border border-slate-800 bg-slate-900 p-2">
        <Input
          type="email"
          autoComplete="off"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="email@example.com"
          disabled={busy}
          className="border-none bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0"
        />
        <Button type="submit" size="sm" disabled={!valid || busy}>
          {busy ? "…" : buttonLabel}
        </Button>
      </div>
      {error && <p className="px-1 text-xs text-red-400">{error}</p>}
    </form>
  );
}
